import React, { useMemo, useState } from 'react';
import { IonList, IonSearchbar, IonItem, IonLabel, IonButton, IonIcon } from '@ionic/react';
import { add, gitBranch } from 'ionicons/icons';
import { IssueFlaggerTable } from '../parameters-schema';
import EditorSelectionItem from './editor-selection-item';

interface InferenceRuleListProps {
  inferenceRules: IssueFlaggerTable[];
  onSelectRule: (id: string) => void;
  onCreateRule: () => void;
  activeRuleId?: string;
  listMaxHeight?: string;
}

const InferenceRuleList: React.FC<InferenceRuleListProps> = ({
  inferenceRules,
  onSelectRule,
  onCreateRule,
  activeRuleId,
  listMaxHeight = '60vh'
}) => {
  const [query, setQuery] = useState('');

  const filteredRules = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return inferenceRules;

    return inferenceRules.filter(rule => {
      const title = rule.displayTitle || rule.id;
      return title.toLowerCase().includes(normalizedQuery);
    });
  }, [inferenceRules, query]);

  return (
    <div style={{ padding: '0.5rem' }} className="inference-rule-list">
      <IonSearchbar
        value={query}
        onIonInput={e => setQuery(e.detail.value || '')}
        placeholder="Search inference rules"
        debounce={200}
      />
      <IonButton
        expand="block"
        color="primary"
        className="inference-rule-list__create"
        onClick={onCreateRule}
      >
        <IonIcon slot="start" icon={add} />
        New Inference Rule
      </IonButton>
      <div
        className="inference-rule-list__scroll"
        style={{ maxHeight: listMaxHeight, overflow: 'auto' }}
      >
        <IonList>
        {filteredRules.length > 0 ? (
          filteredRules.map(rule => (
            <EditorSelectionItem
              key={rule.id}
              label={rule.displayTitle || rule.id}
              description={rule.parameterDescription || 'Inference rule'}
              icon={gitBranch}
              isActive={activeRuleId === rule.id}
              onClick={() => onSelectRule(rule.id)}
            />
          ))
        ) : (
          <IonItem lines="none">
            <IonLabel color="medium">No inference rules match this search.</IonLabel>
          </IonItem>
        )}
        </IonList>
      </div>
    </div>
  );
};

export default InferenceRuleList;
